import React from 'react';
import {
    Box,
    Grid,
    SvgIconProps,
    Tooltip
} from '@mui/material';
import {
    Paper,
    Title
} from '../StyledComponents';

type TitlePropsType =
    'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'body2'
    | 'caption'
    | 'button'
    | 'overline'
    | 'inherit'
    | undefined;

type PropsType = {
    title?: string,
    subTitle?: string,
    contentPadding?: boolean,
    ActionComponent?: JSX.Element,
    IconComponent?: React.JSXElementConstructor<SvgIconProps>,
    titleVariant?: TitlePropsType,
    subTitleVariant?: TitlePropsType,
    variant?: 'elevation' | 'outlined',
    sx?: object,
    children: React.ReactNode,
    infoTooltip?: { icon: JSX.Element, title: string }
};

export default function Block(props: PropsType) {
    const {
        title,
        subTitle,
        children,
        ActionComponent,
        IconComponent,
        titleVariant = 'h6',
        subTitleVariant = 'subtitle2',
        contentPadding = false,
        variant = 'elevation',
        sx,
        infoTooltip
    } = props;

    return (
        <Paper padding={0} variant={variant} sx={sx}>
            {(title || ActionComponent) && (
                <Grid
                    container
                    alignContent="space-between"
                    alignItems="center"
                    sx={{ p: 2, pb: 1 }}
                >
                    <Grid
                        item
                        xs={12}
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            gap: 1,
                            rowGap: 1.5
                        }}
                    >
                        {IconComponent && (
                            <IconComponent
                                color="primary"
                            />
                        )}
                        {infoTooltip && (
                            <Box>
                                <Tooltip title={infoTooltip.title}>
                                    {infoTooltip.icon}
                                </Tooltip>
                            </Box>
                        )}
                        <Title
                            variant={titleVariant}
                            sx={{
                                mt: '5px',
                                flex: '1 1 auto',
                                minWidth: 0
                            }}
                        >
                            {title}
                        </Title>
                        {ActionComponent && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 1,
                                    ml: { xs: 0, sm: 'auto' },
                                    width: { xs: '100%', sm: 'auto' },
                                    justifyContent: { xs: 'flex-start', sm: 'flex-end' }
                                }}
                            >
                                {ActionComponent}
                            </Box>
                        )}
                    </Grid>
                    {subTitle && (
                        <Grid item xs={12}>
                            <Title variant={subTitleVariant}>
                                {subTitle}
                            </Title>
                        </Grid>
                    )}
                </Grid>
            )}
            <Box sx={contentPadding ? { p: 2, mt: -2 } : {}}>
                {children}
            </Box>
        </Paper>
    );
}
